export const identity = (x: any) => x;
